module.exports = __webpack_public_path__ + "img/foreup-logo.e8baa7f5.png";